import React from "react";

import { useIntl } from "react-intl";

import styles from "./Info.module.scss";
import { messages } from "./messages";

type Props = {
  hasAdditionalFilters?: boolean;
  informationPoint?: React.ReactNode;
};

const Info: React.FC<Props> = ({ hasAdditionalFilters, informationPoint }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div>
        {intl.formatMessage({
          id: "downloadEntities.modal.info.title",
          defaultMessage: "This download will include",
          description: "Download entities modal - info - title",
        })}
      </div>
      <ul className={styles.list}>
        {[
          informationPoint ?? intl.formatMessage(messages.point1),
          hasAdditionalFilters
            ? intl.formatMessage(messages.point2withAdditionalFilters)
            : intl.formatMessage(messages.point2),
        ].map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default Info;
